class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.syncWeddingServiceCheckoutPath();

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  syncWeddingServiceCheckoutPath() {
    const product = this.querySelector('[data-dot-cart-contains-wedding]');
    const containsWeddingService = product?.dataset.dotCartContainsWedding === 'true';
    const weddingQuantityValid = product?.dataset.dotWeddingQuantityValid !== 'false';
    const reviewLink = this.querySelector('[data-dot-cart-review]');
    const directCheckout = this.querySelector('[data-dot-direct-checkout]');
    const notice = this.querySelector('[data-dot-wedding-notice]');
    const quantityWarning = this.querySelector('[data-dot-wedding-quantity-warning]');

    if (reviewLink) {
      reviewLink.textContent = containsWeddingService
        ? weddingQuantityValid
          ? 'Review policies and continue'
          : 'Fix quantity and review policies'
        : reviewLink.textContent;
      reviewLink.classList.toggle('button--primary', containsWeddingService);
      reviewLink.classList.toggle('button--secondary', !containsWeddingService);
      if (containsWeddingService) {
        reviewLink.dataset.dotAction = 'policy-review';
        reviewLink.dataset.dotLocation = 'cart-notification';
      } else {
        delete reviewLink.dataset.dotAction;
        delete reviewLink.dataset.dotLocation;
      }
    }

    if (directCheckout) directCheckout.hidden = containsWeddingService;
    if (notice) notice.hidden = !containsWeddingService;
    if (quantityWarning) quantityWarning.hidden = !containsWeddingService || weddingQuantityValid;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
